<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    name: "refund",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 填写物流信息
        fillLogistics(id) {
            this.$emit('fill-logistics', id);
        },
        // 撤销申请
        revokeApplication(id) {
            this.$emit('revoke-application', id);
        },
    },
};
</script>

<template>
    <div class="refund table">
        <div class="item thead only_pc">
            <div class="tr">
                <div class="td">订单信息</div>
                <div class="td">退款金额</div>
                <div class="td">申请时间</div>
                <div class="td">服务类型</div>
                <div class="td">退款状态</div>
                <div class="td">退款操作</div>
            </div>
        </div>
        <div class="item" v-for="(item, index) in data" :key="index">
            <div class="top flex align_center">
                <p class="time">{{ item.time }}</p>
                <p class="code">订单号：{{ item.order_code }}</p>
            </div>
            <!-- pc -->
            <div class="tr only_pc">
                <div class="td">
                    <div class="info">
                        <router-link class="cover layout_bg" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.item_id}`"></router-link>
                        <div class="wrapper">
                            <p class="name">
                                <router-link :to="`/shop/detail?id=${item.item_id}`">{{item.name}}</router-link>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="td price layout_flex_center">RMB {{item.price}}</div>
                <div class="td gray layout_flex_center">{{ item.created_at }}</div>
                <div class="td red layout_flex_center">{{item.service_type}}</div>
                <div class="td red layout_flex_center">
                    <p class="red"  v-if="item.status == 0">申请中</p>
                    <p class="green"  v-if="item.status == 1">申请通过</p>
                    <p class="green" v-if="item.status == 2">退款成功</p>
                    <p class="red" v-if="item.status == 3">已撤销</p>
                </div>
                <div class="td layout_flex_center">
                    <div class="btn_group">
                        <div class="btn layout_flex_center" v-if="item.status == 1" @click="fillLogistics(item.id)">填写物流信息</div>
                        <div class="btn layout_flex_center" v-if="item.status == 0" @click="revokeApplication(item.id)">撤销申请</div>
                    </div>
                </div>
            </div>
            <!-- 移动端 -->
            <div class="only_mobile">
                <div class="info">
                    <router-link class="cover layout_bg" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.item_id}`"></router-link>
                    <div class="wrapper">
                        <p class="name"><router-link :to="`/shop/detail?id=${item.item_id}`">{{item.name}}</router-link></p>
                        <!-- <p class="count">x{{item.count}}</p> -->
                        <p class="price">实际付款 RMB {{item.price}}</p>
                    </div>
                </div>
                <div class="btn_group">
                    <p class="red"  v-if="item.status == 0">申请中</p>
                    <p class="green"  v-if="item.status == 1">申请通过</p>
                    <p class="green" v-if="item.status == 2">退款成功</p>
                    <p class="red" v-if="item.status == 3">已撤销</p>
                    <div class="btn layout_flex_center" v-if="item.status == 1" @click="fillLogistics(item.id)">填写物流信息</div>
                    <div class="btn layout_flex_center" v-if="item.status == 0" @click="revokeApplication(item.id, true)">撤销申请</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import './table.scss';
.refund{
    .tr{
        .td{
            flex: 1;
            &:nth-of-type(1){
                flex: none;
                width: 38%;
            }
            &:nth-of-type(6){
                flex: 2;
            }
        }
    }
    .gray{
        color: #999;
    }
    .red{
        color: #ff0000;
    }
    .green{
        color: #13bf34;
    }
}
</style>